class LocalStorage {
    static set(key, value, ttl=1) {
      const now = new Date();

      const item = {
        value: value,
        expiry: now.getTime() + ttl,
      };
      localStorage.setItem(key, JSON.stringify(item));
    }
    static get(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }
      const item = JSON.parse(itemStr);
      const now = new Date();
      if (now.getTime() > item.expiry) {
        return item.value;
        
      }
      return item.value;
    }
  }
  export default LocalStorage;
  